import React from "react";
import { Row, Col } from "antd";
import {
  InputItem,
  DatePickerItem,
  SelectItem as SelectItemComponent,
} from "../../../components/forms/FormItems";
import {
  BranchSelect,
  MetaDataSelect,
} from "../../../components/forms/AutoCompleteFormItem";
import RadioButtonItem from "../../../components/forms/RadioButtonItem";
import { useLocation } from "react-router-dom";
import ChildrenAnimationWrapper from "../../../components/animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import moment from "moment";

const EmployeePersonal = (props) => {
  const { values } = props;
  const disabledDate = (current) => {
    const startdate = moment().subtract(16, "years");
    return current && current > startdate;
  };
  const defaultPickerValue = moment().subtract(16, "years");
  let location = useLocation();

  return (
    <ChildrenAnimationWrapper>
      <Row>
        <Col span={24}>
          <ResponsiveItemsWrapper>
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={1}>
                <InputItem
                  required={true}
                  name="first_name"
                  category="employee"
                />
              </AnimationChildWrapper>
            </div>
            <Spacer horizontal={true} />
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={2}>
                <InputItem
                  required={true}
                  name="surename"
                  category="employee"
                />
              </AnimationChildWrapper>
            </div>
          </ResponsiveItemsWrapper>

          <ResponsiveItemsWrapper>
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={3}>
                <InputItem
                  name="accounting_info.number"
                  category="employee"
                  number={true}
                />
              </AnimationChildWrapper>
            </div>
            <Spacer horizontal={true} />
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={4}>
                <MetaDataSelect
                  name="accounting_info.department_id"
                  category="employee"
                  metadataName={"departments"}
                />
              </AnimationChildWrapper>
            </div>
          </ResponsiveItemsWrapper>

          <ResponsiveItemsWrapper>
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={5}>
                <InputItem
                  required={true}
                  name="local_id_number"
                  id={true}
                  category="employee"
                />
              </AnimationChildWrapper>
            </div>
            <Spacer horizontal={true} />
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={6}>
                <DatePickerItem
                  required={true}
                  name="birthday"
                  category="employee"
                  disabledDate={disabledDate}
                  defaultPickerValue={defaultPickerValue}
                />
              </AnimationChildWrapper>
            </div>
          </ResponsiveItemsWrapper>

          <ResponsiveItemsWrapper>
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={7}>
                <SelectItemComponent
                  name="family_status"
                  category="employee"
                  marital={true}
                />
              </AnimationChildWrapper>
            </div>
            <Spacer horizontal={true} />
            <div style={{ flex: 1 }}>
              <AnimationChildWrapper itemKey={8}>
                <RadioButtonItem
                  required={true}
                  name="gender_id"
                  category="employee"
                  genders={true}
                  translated={true}
                />
              </AnimationChildWrapper>
            </div>
          </ResponsiveItemsWrapper>

          <ResponsiveItemsWrapper>
            <div style={{ flex: 1 }}>
              {values.is_professional_employee === "professional" ? (
                <AnimationChildWrapper itemKey={9}>
                  <MetaDataSelect
                    name="professional_role_id"
                    required={true}
                    category="employee"
                    metadataName={"professional_roles"}
                  />
                </AnimationChildWrapper>
              ) : null}
            </div>
            <Spacer horizontal={true} />
            <div style={{ flex: 1 }}>
              {location.pathname.includes("admin") ? (
                <AnimationChildWrapper itemKey={10}>
                  <BranchSelect
                    name="branch"
                    category="employee"
                    required={true}
                  />
                </AnimationChildWrapper>
              ) : null}
            </div>
          </ResponsiveItemsWrapper>
        </Col>
      </Row>
    </ChildrenAnimationWrapper>
  );
};

export default EmployeePersonal;
